


import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const constantRoutes = [
    {
        path: "/home",
        component: () => import("@/views/home"),
        hidden: true
    },
    {
        path: "/detail",
        component: () => import("@/views/detail"),
        hidden: true
    },
    {
        path: "/",
        // component: Layout,
        component: () => import("@/views/home"),
        isfirst: true,
        redirect: "/home",
        name: "首页",
        children: [
            {
                path: "/home",
                component: () => import("@/views/home"),
                name: "首页",
            }
        ]
    }
];

const createRouter = () =>
    new Router({
    // mode: "history", // require service support
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
